(function ($) {
    window.setCookie = function(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
  
    window.addUpsellToCart = function(target) {
      if (target.getAttribute('disabled') === 'disabled') {
        return;
      }
    
      const variantId = target.getAttribute('data-variant-id');
      let quantity = 1;

      // Find the closest quantity input if it exists
      const quantityInput = $(target).closest('.upsell-product').find('.upsell-quantity-input');
      if (quantityInput.length) {
        // Get the value and ensure it's within bounds
        quantity = parseInt(quantityInput.val()) || 1;
        const min = parseInt(quantityInput.attr('min')) || 1;
        const max = parseInt(quantityInput.attr('max')) || 1;

        if (quantity < min) {
          quantity = min;
          quantityInput.val(min);
        } else if (quantity > max) {
          quantity = max;
          quantityInput.val(max);
        }
      }
  
      target.style.opacity = '0.5';
      target.setAttribute('disabled', 'disabled');
  
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: quantity
        },
        dataType: 'json',
        success: function(data) {
          if (window.SilberthalCart && window.SilberthalCart.afterAdd) {
            window.SilberthalCart.afterAdd().finally(function () {
              target.style.opacity = '1';
              target.removeAttribute('disabled');
            });
          } else {
            window.setCookie('show_cart', 'true', 1);
            window.location.reload(true);
          }
        },
        error: function(xhr, status, error) {
          console.error('Error adding product to cart:', error);
          target.style.opacity = '1';
          target.removeAttribute('disabled');
          alert('Failed to add product to cart. Please try again.');
        }
      });
    };

    // Add handlers for quantity buttons
    $(document).on('click', '.upsell-quantity .oci-plus', function(e) {
      e.preventDefault();
      const input = $(this).siblings('.upsell-quantity-input');
      const currentVal = parseInt(input.val()) || 1;
      const max = parseInt(input.attr('max')) || 1;
      if (currentVal < max) {
        input.val(currentVal + 1);
      }
    });

    $(document).on('click', '.upsell-quantity .oci-minus', function(e) {
      e.preventDefault();
      const input = $(this).siblings('.upsell-quantity-input');
      const currentVal = parseInt(input.val()) || 1;
      const min = parseInt(input.attr('min')) || 1;
      if (currentVal > min) {
        input.val(currentVal - 1);
      }
    });

    // Add handler for direct input
    $(document).on('change', '.upsell-quantity-input', function() {
      const min = parseInt($(this).attr('min')) || 1;
      const max = parseInt($(this).attr('max')) || 1;
      let val = parseInt($(this).val()) || min;

      if (val < min) {
        val = min;
      } else if (val > max) {
        val = max;
      }

      $(this).val(val);
    });

})(jQuery);
